module.exports = __webpack_public_path__ + "static/media/chat-gray.ec7fcc10.svg";